import moment from 'moment';

export const dateOptions = [{
  label: 'Live',
  value: 0,
  disabled: false,
  advanced: true,
  liveMode: true
}, {
  label: '24 Hours',
  value: 1,
  disabled: false,
  advanced: false,
}, {
  label: '7 Days',
  value: 7,
  disabled: false,
  advanced: false,
}, {
  label: '30 Days',
  value: 30,
  disabled: false,
  advanced: true,
}];

export const getLocalTime = (date, tzOffset) => {
  return moment.utc(date).utcOffset(tzOffset).format();
}
